import * as React from 'react'
import { Link } from 'gatsby'

import styled from '@emotion/styled'
import Page from '../components/Page'
import Container from '../components/Container'
import IndexLayout from '../layouts'
import { heights } from '../styles/variables'
import Hero from './issues/Hero'
import IssueItems from './issues/IssueItems'

const Issues = () => (
  <IndexLayout>
    <Page>
      <Container>
        <Hero />
        <IssueItems />
      </Container>
    </Page>
  </IndexLayout>
)

const IssueHeader = styled.h2`
  padding-top: ${heights.header + 10}px;
`
const IssueBody = styled.p``

export default Issues
